import React, { useEffect, useRef, useState } from "react";
import { Search } from "lucide-react";
import { api } from "../lib/api";
import { namaGelar } from "../lib/utils";
import { Input } from "./ui/input";

// Cari jemaat berdasarkan nama → onPilih(jemaat) (mengisi NIJ otomatis)
export const JemaatNamaPicker = ({ onPilih, placeholder = "Ketik nama jemaat…", testId = "jemaat-picker", awal = "" }) => {
  const [q, setQ] = useState(awal); const [hasil, setHasil] = useState([]); const [buka, setBuka] = useState(false); const box = useRef(null);
  useEffect(() => { setQ(awal); setBuka(false); }, [awal]);
  useEffect(() => {
    if (q.trim().length < 2) { setHasil([]); return; }
    const t = setTimeout(() => api.get("/kunjungan/cari-nama", { params: { q } }).then((r) => { setHasil(r.data.items); setBuka(true); }).catch(() => setHasil([])), 250);
    return () => clearTimeout(t);
  }, [q]);
  useEffect(() => { const h = (e) => { if (box.current && !box.current.contains(e.target)) setBuka(false); }; document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h); }, []);
  return (
    <div ref={box} className="relative" data-testid={testId}>
      <Search className="h-4 w-4 absolute left-3 top-3.5 text-slate-400" />
      <Input value={q} onChange={(e) => setQ(e.target.value)} onFocus={() => hasil.length && setBuka(true)} placeholder={placeholder} className="pl-9 min-h-[44px]" data-testid={`${testId}-input`} />
      {buka && hasil.length > 0 && (
        <div className="absolute z-30 mt-1 w-full rounded-xl border bg-white shadow-lg max-h-64 overflow-auto text-sm" data-testid={`${testId}-dropdown`}>
          {hasil.map((j) => <button key={j.id} type="button" onClick={() => { onPilih(j); setQ(j.nama_lengkap); setBuka(false); }} className="w-full text-left px-3 py-2.5 hover:bg-slate-50 flex items-center justify-between gap-2" data-testid={`${testId}-opsi-${j.id}`}><span className="truncate">{namaGelar(j)}</span><span className="text-xs text-slate-500 font-mono whitespace-nowrap">{j.nij}{j.komisi ? ` · ${j.komisi}` : ""}</span></button>)}
        </div>)}
      {buka && q.trim().length >= 2 && hasil.length === 0 && <div className="absolute z-30 mt-1 w-full rounded-xl border bg-white shadow-lg p-3 text-xs text-slate-500">Tidak ada jemaat yang cocok.</div>}
    </div>
  );
};
